module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "warp maincont clear-parent-padding"
  }, [_c('el-col', {
    staticClass: "head",
    attrs: {
      "span": 24
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "warp-breadcrum",
    staticStyle: {
      "margin": "20px 0px 0px 10px"
    },
    attrs: {
      "span": 8
    }
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('b', [_vm._v("首页")])]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("大屏监控")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('h1', [_vm._v("数据汇聚管理平台")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "weather"
  }, [_c('span', [_vm._v(_vm._s(_vm.datetime))])])])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "warp-main",
    attrs: {
      "span": 24
    }
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "li1"
  }, [_c('div', {
    staticClass: "mbox sm",
    staticStyle: {
      "z-index": "90",
      "height": "910px",
      "overflow": "auto"
    }
  }, _vm._l((_vm.deviceType), function(item, index) {
    return _c('a', {
      key: index,
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.loadOther(item.id + '')
        }
      }
    }, [_c('div', {
      staticClass: "iconbox cor0"
    }, [(item.iconUrl) ? _c('img', {
      staticStyle: {
        "height": "30px",
        "width": "30px"
      },
      attrs: {
        "src": item.iconUrl,
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('h2', {
      staticStyle: {
        "white-space": "nowrap",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)]), _vm._v(" "), _c('li', {
    staticClass: "li4"
  }, [_c('div', {
    staticClass: "mbox hl"
  }, [_c('div', {
    staticClass: "alltitle"
  }, [_vm._v("设备报警故障统计")]), _vm._v(" "), _c('div', {
    staticClass: "dafen"
  }, [_c('div', {
    staticClass: "sanfen",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showDevice({
          alarmType: 'alarm'
        })
      }
    }
  }, [_c('h1', [_c('animate-number', {
    key: _vm.loadTimes,
    attrs: {
      "from": "0",
      "to": _vm.eventStatic.alarm == null ? 0 : _vm.eventStatic.alarm
    }
  })], 1), _vm._v(" "), _c('h2', [_vm._v("报警数")])]), _vm._v(" "), _c('div', {
    staticClass: "sanfen",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showDevice({
          alarmType: 'breakdown'
        })
      }
    }
  }, [_c('h1', [_c('animate-number', {
    key: _vm.loadTimes,
    attrs: {
      "from": "0",
      "to": _vm.eventStatic.breakdown == null ? 0 : _vm.eventStatic.breakdown
    }
  })], 1), _vm._v(" "), _c('h2', [_vm._v("故障数")])]), _vm._v(" "), _c('div', {
    staticClass: "sanfen",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showDevice({})
      }
    }
  }, [_c('h1', [_c('animate-number', {
    key: _vm.loadTimes,
    attrs: {
      "from": "0",
      "to": _vm.eventStatic.device == null ? 0 : _vm.eventStatic.device
    }
  })], 1), _vm._v(" "), _c('h2', [_vm._v("设备总数")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mbox hl",
    staticStyle: {
      "left": "20px"
    }
  }, [_c('div', {
    staticClass: "alltitle"
  }, [_vm._v("设备状态统计")]), _vm._v(" "), _c('div', {
    staticClass: "dafen"
  }, [_c('div', {
    staticClass: "sanfen",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showDevice({
          stateType: 1
        })
      }
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('animate-number', {
    key: _vm.loadTimes,
    attrs: {
      "from": "0",
      "to": _vm.deviceStateStatic.online == null ? 0 : _vm.deviceStateStatic.online
    }
  })], 1), _vm._v(" "), _c('h2', [_c('i', {
    staticClass: "fa fa-circle",
    staticStyle: {
      "color": "green"
    },
    attrs: {
      "data-v-afc86c0c": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" 在线")])]), _vm._v(" "), _c('div', {
    staticClass: "sanfen",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showDevice({
          stateType: 2
        })
      }
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('animate-number', {
    key: _vm.loadTimes,
    attrs: {
      "from": "0",
      "to": _vm.deviceStateStatic.unline == null ? 0 : _vm.deviceStateStatic.unline
    }
  })], 1), _vm._v(" "), _c('h2', [_c('i', {
    staticClass: "fa fa-circle",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "data-v-afc86c0c": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" 离线")])]), _vm._v(" "), _c('div', {
    staticClass: "sanfen",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showDevice({
          stateType: 0
        })
      }
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "yellow"
    }
  }, [_c('animate-number', {
    key: _vm.loadTimes,
    attrs: {
      "from": "0",
      "to": _vm.deviceStateStatic.unknow == null ? 0 : _vm.deviceStateStatic.unknow
    }
  })], 1), _vm._v(" "), _c('h2', [_c('i', {
    staticClass: "fa fa-circle",
    staticStyle: {
      "color": "yellow"
    },
    attrs: {
      "data-v-afc86c0c": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" 未知")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mbox max",
    staticStyle: {
      "height": "48em"
    }
  }, [_c('div', {
    staticClass: "shuju"
  }, [_c('ul', _vm._l((_vm.newDeviceEvent), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "sone"
    }, [_c('span', [_vm._v(_vm._s(item.happenTime))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": ""
      }
    }, [_vm._v(_vm._s(item.eventName))])]), _vm._v(" "), _c('p', [_vm._v("设备号：" + _vm._s(item.deviceCode))]), _vm._v(" "), _c('p', [_vm._v("告警值：" + _vm._s(item.eventValue))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.address))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "map"
  }, [_c('div', {
    staticClass: "map1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/lbx.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "map2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/jt.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "map3"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/map.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "map4",
    attrs: {
      "id": "echart-china"
    }
  })])])]), _vm._v(" "), _c('li', {
    staticClass: "li5"
  }, [_c('div', {
    staticClass: "mbox max",
    staticStyle: {
      "height": "18em"
    }
  }, [_c('div', {
    staticClass: "alltitle"
  }, [_vm._v("设备报警故障明细")]), _vm._v(" "), _c('table', {
    staticClass: "mtab",
    attrs: {
      "border": "0",
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("设备类型")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("报警")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("故障")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("总数")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "13rem",
      "width": "100%",
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "mtab",
    attrs: {
      "border": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', _vm._l((_vm.deviceEventStatic), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('animate-number', {
      key: _vm.loadTimes,
      attrs: {
        "from": "0",
        "to": item.alarm
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('animate-number', {
      key: _vm.loadTimes,
      attrs: {
        "from": "0",
        "to": item.breakdown
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('animate-number', {
      key: _vm.loadTimes,
      attrs: {
        "from": "0",
        "to": item.device
      }
    })], 1)])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "mbox max",
    staticStyle: {
      "height": "19rem"
    }
  }, [_c('div', {
    staticClass: "alltitle"
  }, [_vm._v("报警故障处理占比")]), _vm._v(" "), _c('div', {
    staticClass: "allnav",
    attrs: {
      "id": "echart5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "boxfoot"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mbox max",
    staticStyle: {
      "height": "18rem"
    }
  }, [_c('div', {
    staticClass: "alltitle"
  }, [_vm._v("报警占比")]), _vm._v(" "), _c('div', {
    staticClass: "allnav",
    attrs: {
      "id": "echart6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "boxfoot"
  })])])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-dialog', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "title": "设备详情",
      "visible": _vm.device.visible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.device, "visible", $event)
      }
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.device.data,
      "highlight-current-row": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "deviceCode",
      "label": "设备编号",
      "width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deviceName",
      "label": "设备名称",
      "width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "projectName",
      "label": "项目",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "supplierName",
      "label": "设备供应商",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.device.limit,
      "background": "",
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.device.total
    },
    on: {
      "size-change": _vm.device.handleSizeChange,
      "current-change": _vm.device.handleCurrentChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "项目详情",
      "visible": _vm.project.visible,
      "close-on-click-modal": false,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.project, "visible", $event)
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.project.openMap($event)
      }
    }
  }, [_vm._v("打开地图")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.project.data,
      "highlight-current-row": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "projectName",
      "label": "项目名称",
      "width": "200",
      "align": "center",
      "show-overflow-tooltip": "",
      "fixed": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "custName",
      "label": "所属企业",
      "width": "250",
      "align": "center",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "provinceName",
      "label": "省",
      "width": "160",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "市",
      "width": "160",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "districtName",
      "label": "区",
      "width": "160",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "项目地址",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deviceTotal",
      "label": "设备总数",
      "width": "100",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.project.limit,
      "background": "",
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.project.total
    },
    on: {
      "size-change": _vm.project.handleSizeChange,
      "current-change": _vm.project.handleCurrentChange
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65451db1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screen.vue
// module id = 1176
// module chunks = 2